import CommonBanner from "./global-components/common_banner";
import Footer from "./global-components/footer";
import Subscribe from "./global-components/subscribe";
import TopNav from "./global-components/top_nav";
import Tourorderlist from "./tour-list/tour_order_list";
const Attractions = () => {
  return (
    <>
    <TopNav/>
      <CommonBanner title="Attractions" imgUrl ="attBanner.jpeg"/>
      <Tourorderlist />
      <Subscribe/>
      <Footer/>
    </>
  );
};

export default Attractions;
